import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, storeToken } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { KeyRound } from "lucide-react";

export default function StaffLogin() {
    const [email, setEmail] = useState("");
    const [pin, setPin] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const nav = useNavigate();
    const { setUser } = useAuth();

    const submit = async (e) => {
        e.preventDefault();
        if (!/^\d{4}$/.test(pin)) {
            toast.error("Il PIN deve essere di 4 cifre");
            return;
        }
        setSubmitting(true);
        try {
            const { data } = await api.post("/auth/staff/pin", { email, pin });
            storeToken(data.access_token);
            setUser(data.user);
            sessionStorage.setItem("staff_timeout_min", String(data.session_timeout_min || 3));
            toast.success("Sessione staff attiva");
            nav("/staff", { replace: true });
        } catch (err) {
            toast.error(err.response?.data?.detail || "Accesso non riuscito");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))]" data-testid="staff-login-page">
            <form onSubmit={submit} className="w-full max-w-sm bg-white border border-[hsl(var(--border))] rounded-sm p-8 space-y-5">
                <div className="text-center mb-2">
                    <KeyRound className="w-8 h-8 mx-auto text-[hsl(var(--primary))]" strokeWidth={1.2} />
                    <h1 className="text-2xl mt-3">Staff · Orterie</h1>
                    <p className="text-xs text-[hsl(var(--muted-foreground))] mt-1">
                        Accesso con PIN personale
                    </p>
                </div>
                <div>
                    <label className="co-caption text-xs">Email</label>
                    <Input
                        type="email"
                        autoComplete="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        data-testid="staff-email-input"
                    />
                </div>
                <div>
                    <label className="co-caption text-xs">PIN (4 cifre)</label>
                    <Input
                        inputMode="numeric"
                        pattern="\d{4}"
                        maxLength={4}
                        value={pin}
                        onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
                        required
                        data-testid="staff-pin-input"
                        className="text-center text-2xl tracking-[.4em]"
                    />
                </div>
                <button
                    type="submit"
                    disabled={submitting || pin.length !== 4}
                    className="co-btn-primary w-full justify-center"
                    data-testid="staff-pin-submit"
                >
                    {submitting ? "Verifica…" : "Accedi"}
                </button>
            </form>
        </div>
    );
}
